import * as React from "react";
import type { SVGProps } from "react";
const SvgGovernanceAtScale = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={66}
    height={66}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M7.913 2.643a5.27 5.27 0 0 0-5.27 5.27v50.174a5.27 5.27 0 0 0 5.27 5.27h50.174a5.27 5.27 0 0 0 5.27-5.27V7.913a5.27 5.27 0 0 0-5.27-5.27H7.913Zm-7.02 5.27a7.02 7.02 0 0 1 7.02-7.02h50.174a7.02 7.02 0 0 1 7.02 7.02v50.174a7.02 7.02 0 0 1-7.02 7.02H7.913a7.02 7.02 0 0 1-7.02-7.02V7.913Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M53.047 12.799a1 1 0 0 1 .006 1.414L14.367 53.196a1 1 0 1 1-1.42-1.41l38.686-38.982a1 1 0 0 1 1.414-.005Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="m44.027 12.667.063 1.588 7.824-.317-.254 7.829 1.588.047.307-9.528-9.528.381ZM12.752 44.185l1.588.048-.254 7.824 7.824-.312.063 1.588-9.533.381.312-9.529Z"
    />
    <path
      fill="#D3ECF8"
      fillRule="evenodd"
      d="M12.799 12.953a1 1 0 0 1 1.414-.006l38.983 38.686a1 1 0 0 1-1.41 1.42L12.805 14.367a1 1 0 0 1-.005-1.414Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="m12.667 21.973 1.588-.063-.317-7.824 7.829.254.048-1.588-9.529-.307.381 9.528ZM44.185 53.248l.048-1.588 7.824.26-.312-7.83 1.588-.063.381 9.533-9.529-.312ZM33 43.328c5.704 0 10.328-4.624 10.328-10.328S38.704 22.672 33 22.672 22.672 27.296 22.672 33 27.296 43.328 33 43.328Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M33 41.578a8.578 8.578 0 1 0 0-17.156 8.578 8.578 0 0 0 0 17.156ZM43.328 33c0 5.704-4.624 10.328-10.328 10.328S22.672 38.704 22.672 33 27.296 22.672 33 22.672 43.328 27.296 43.328 33Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGovernanceAtScale;
